import {
  Building,
  Calendar2Week,
  ChatSquareText,
  Cpu,
  House,
  Mortarboard,
  PatchCheck,
  PeopleFill,
  PersonVideo2,
  PlayBtn,
  PlayCircle,
  RocketTakeoff,
  ShieldCheck,
  ShieldSlash,
  Star,
} from 'react-bootstrap-icons';

import { PAGE_TITLES, ROUTES } from '@repo/common';
import { DataTestIds } from '@repo/frontend-shared';
import { SDSIcon } from '@repo/sds/SDSIcon';
import { Sidebar } from '@repo/ui/components/elements/Sidebar/Sidebar';

const adminSidebarItems = [
  {
    icon: <SDSIcon icon={<House />} />,
    title: 'Dashboard',
    path: ROUTES.ADMIN_DASHBOARD,
    testid: DataTestIds.COMMON.SIDEBAR.DASHBOARD,
  },
  {
    icon: <SDSIcon icon={<Mortarboard />} />,
    title: PAGE_TITLES.CLIENT.COURSES,
    path: ROUTES.ADMIN_COURSES,
    testid: DataTestIds.COMMON.SIDEBAR.COURSES,
  },
  {
    icon: <SDSIcon icon={<PatchCheck />} />,
    title: PAGE_TITLES.ADMIN.CERTIFICATES,
    path: ROUTES.ADMIN_CERTIFICATES,
    testid: DataTestIds.ADMIN.SIDEBAR.CERTIFICATES,
  },
  {
    icon: <SDSIcon icon={<Mortarboard />} />,
    title: PAGE_TITLES.ADMIN.MBA_OPERATIONS,
    path: ROUTES.ADMIN_MBA_OPERATIONS,
    testid: DataTestIds.ADMIN.SIDEBAR.MBA_OPERATIONS,
  },
  {
    icon: <SDSIcon icon={<ShieldSlash />} />,
    title: PAGE_TITLES.ADMIN.PAYMENT_DISPUTES,
    path: ROUTES.ADMIN_PAYMENT_DISPUTES,
    testid: DataTestIds.ADMIN.SIDEBAR.PAYMENT_DISPUTES,
  },
  {
    icon: <SDSIcon icon={<ShieldCheck />} />,
    title: PAGE_TITLES.ADMIN.MEETING_REFUND_JOBS,
    path: ROUTES.ADMIN_MEETING_REFUND_JOBS,
    testid: DataTestIds.ADMIN.SIDEBAR.MEETING_REFUND_JOBS,
  },
  {
    icon: <SDSIcon icon={<PlayBtn />} />,
    title: PAGE_TITLES.ADMIN.VIDEOS,
    path: ROUTES.ADMIN_VIDEOS,
    testid: DataTestIds.ADMIN.SIDEBAR.VIDEOS,
  },
  {
    icon: <SDSIcon icon={<PlayCircle />} />,
    title: PAGE_TITLES.CLIENT.TOOLS_TEMPLATES,
    path: ROUTES.ADMIN_TOOLS_AND_TEMPLATES,
    testid: DataTestIds.COMMON.SIDEBAR.TOOLS_TEMPLATES,
  },
  {
    icon: <SDSIcon icon={<Calendar2Week />} />,
    title: PAGE_TITLES.ADMIN.EVENTS,
    path: ROUTES.ADMIN_EVENTS,
    testid: DataTestIds.ADMIN.SIDEBAR.EVENTS,
  },
  {
    icon: <SDSIcon icon={<PersonVideo2 />} />,
    title: PAGE_TITLES.ADMIN.MENTORS,
    path: ROUTES.ADMIN_MENTORS,
    testid: DataTestIds.ADMIN.SIDEBAR.MENTORS,
  },
  {
    icon: <SDSIcon icon={<ChatSquareText />} />,
    title: PAGE_TITLES.ADMIN.SCENARIOS,
    path: ROUTES.ADMIN_SCENARIOS,
    testid: DataTestIds.ADMIN.SIDEBAR.SCENARIOS,
  },
  {
    icon: <SDSIcon icon={<PeopleFill />} />,
    title: 'Community',
    path: ROUTES.ADMIN_COMMUNITY,
    testid: 'sidebar-community',
  },
  {
    icon: <SDSIcon icon={<RocketTakeoff />} />,
    title: PAGE_TITLES.ADMIN.DEALS_DISCOUNTS,
    path: ROUTES.ADMIN_DISCOUNT_DEALS,
    testid: DataTestIds.COMMON.SIDEBAR.DEALS_DISCOUNTS,
  },
  {
    icon: <SDSIcon icon={<ShieldCheck />} />,
    title: 'Feature Flags',
    path: ROUTES.ADMIN_FEATURE_FLAGS,
    testid: DataTestIds.ADMIN.SIDEBAR.FEATURE_FLAGS,
  },
  {
    icon: <SDSIcon icon={<Star />} />,
    title: PAGE_TITLES.ADMIN.ROLES_PERMISSIONS,
    path: ROUTES.ADMIN_EXTRAS,
    testid: DataTestIds.ADMIN.SIDEBAR.EXTRAS,
  },
  {
    icon: <SDSIcon icon={<Building />} />,
    title: PAGE_TITLES.ADMIN.PARTNERS,
    path: ROUTES.ADMIN_PARTNERS,
    testid: DataTestIds.ADMIN.SIDEBAR.PARTNERS,
  },
  {
    icon: <SDSIcon icon={<Cpu />} />,
    title: 'AI Instructions',
    path: ROUTES.ADMIN_AI_INSTRUCTIONS,
    testid: 'sidebar-ai-instructions',
  },
];

export function AdminSidebar() {
  return <Sidebar items={adminSidebarItems} />;
}
